import { FEATURE_STATES, ROLLOUT_STATE, type FeatureKind, type FeatureState } from '@prerender/feature-flags';

export type FeatureFlagState = FeatureState | typeof ROLLOUT_STATE;

export const RELEASE_FLAG_STATES: readonly FeatureFlagState[] = [...FEATURE_STATES, ROLLOUT_STATE];

export type FeatureFlag = {
  readonly name: string;
  readonly state: FeatureFlagState;
  readonly percent?: number;
  readonly kind: FeatureKind;
  readonly label: string;
};

export const describeFlagState = (state: FeatureFlagState, percent?: number): string =>
  state === ROLLOUT_STATE && percent !== undefined ? `${state} ${percent}%` : state;

export type FlagSide = {
  readonly state: FeatureFlagState;
  readonly percent?: number;
};

const FULL_ROLLOUT_PERCENT = 100;

const admittedPercent = (side: FlagSide): number | undefined =>
  side.state === 'on' ? FULL_ROLLOUT_PERCENT : side.state === ROLLOUT_STATE ? side.percent : undefined;

export const removesFeatureFromHolders = (from: FlagSide, to: FlagSide): boolean => {
  const fromPercent = admittedPercent(from);
  if (fromPercent === undefined) {
    return false;
  }
  if (to.state === ROLLOUT_STATE) {
    return to.percent !== undefined && to.percent < fromPercent;
  }

  return from.state === ROLLOUT_STATE && to.state !== 'on' && fromPercent > 0;
};
